export const Ibans = [
  'DE12 5001 0517 0648 4898 90',
  'DE89 5205 0353 1337 0088 00',
  'DE77 5003 3300 0100 2003 00',
  'DE26 7109 0000 0003 7207 80',
  'DE94 7016 9356 0000 1364 33',
  'DE52 4926 2364 0080 2556 00',
  'DE59 3206 1384 4309 9000 10',
  'DE06 2806 2913 0003 0163 00',
  'DE13 7936 2081 0000 0026 07',
  'DE67 5479 0000 0000 0280 88',
  'DE61 6039 0000 0053 1580 08',
  'DE85 6619 0000 0000 1010 10',
  'DE44 7206 9126 0000 7366 35',
  'DE93 7639 1000 0002 5162 17',
  'DE27 7339 2000 0000 4295 54',
  'DE61 8109 3274 0010 0400 62',
  'DE48 6709 0000 0000 0001 00',
  'DE33 2806 5286 0003 9063 00',
  'DE68 6629 1400 0005 1855 05',
  'DE82 7606 0618 0000 0206 05',
  'DE83 3826 0082 1101 4420 19',
  'DE57 5605 1790 0010 0231 41',
  'DE89 5486 2500 0002 5210 08',
  'DE67 2176 2550 0004 1917 73',
  'DE45 5409 2400 0001 3241 01',
  'DE42 8709 6124 0010 0400 62',
  'DE81 3806 0186 2100 2210 23',
  'DE44 6049 1430 1234 5678 90',
  'DE77 5115 0018 0000 0335 14',
  'DE02 7506 9094 0000 0471 63',
  'DE94 6509 3020 0360 5980 05',
  'DE94 7625 0000 0040 5425 08',
  'DE08 2405 0110 0065 2197 50',
  'DE65 2579 1635 0001 3242 00',
  'DE44 8606 5468 4111 1111 41',
  'DE17 2305 0101 0001 0113 29',
  'DE95 8206 4228 0105 5672 89',
  'DE85 1203 0000 1008 8622 35',
  'DE04 6609 1200 0009 6857 07',
  'DE88 8309 4495 0003 1160 00',
  'DE97 7506 2026 1234 5678 90',
  'DE71 1806 2678 0007 3031 22',
  'DE32 5003 1000 0008 9329 23',
  'DE57 6009 0700 0309 9480 02',
  'DE89 4829 1490 0004 2420 00',
  'DE31 7206 9235 0000 0078 11',
  'DE98 7966 8509 0000 0080 10',
  'DE39 5206 2601 1234 5678 90',
  'DE37 3706 2124 0056 9480 15',
  'DE86 5086 2903 0002 5001 08',
  'DE15 6029 1120 0003 6890 00',
  'DE17 7419 0000 0004 0082 19',
  'DE54 7426 1024 0105 2109 41',
  'DE48 4006 9709 1033 5621 00',
  'DE55 2709 2555 0002 8894 00',
  'DE13 6509 2200 0014 1150 00',
  'DE56 5096 1206 0000 0043 32',
  'DE96 4286 0003 0273 7874 00',
  'DE76 7909 0000 0003 7277 26',
  'DE51 7706 9739 0000 0213 42',
  'DE77 6426 1853 0030 9340 01',
  'DE35 2146 3603 0005 3128 41',
  'DE54 6206 2215 0005 9390 03',
  'DE26 6006 9714 0488 1530 00',
  'DE76 4306 0129 0621 7171 01',
  'DE10 7606 9404 0000 4361 60',
  'DE98 3701 9000 0111 1042 76',
  'DE17 5236 0059 0005 0076 07',
  'DE36 5426 1700 0000 6809 90',
  'DE78 2546 2160 0123 6393 00',
  'DE75 2186 0418 0024 0534 00',
  'DE65 3146 0290 0500 8530 18',
  'DE12 8705 8000 3100 1040 80',
  'DE22 5109 0000 0025 0132 04',
  'DE20 8409 4754 0002 2942 30',
  'DE83 7536 0011 0003 2511 60',
  'DE63 7216 9812 0000 4161 93',
  'DE89 5205 0353 1337 0088 00',
  'DE68 3706 9412 0107 5810 14',
  'DE08 5085 0150 1234 5678 90',
  'DE85 2916 7624 8104 3058 00',
  'DE14 5739 1200 0020 2727 24',
  'DE19 5309 3200 0002 1402 92',
  'DE50 1609 1994 0001 1105 51',
  'DE29 6416 3225 1020 8100 09',
  'DE49 7206 9220 0000 8211 79',
  'DE34 2806 9935 0000 1988 00',
  'DE41 7419 1000 0000 0880 99',
  'DE93 5405 0220 0007 6040 28',
  'DE10 7039 0000 0000 3207 57',
  'DE55 7016 9466 0000 0982 80',
  'DE80 2416 1594 5137 0409 00',
  'DE31 3206 1414 1001 2300 14',
  'DE36 3106 0517 0101 0340 11',
  'DE97 7659 1000 0000 2235 57',
  'DE42 7966 5540 0000 5043 78',
  'DE18 1309 1054 0106 4566 93',
  'DE43 5125 0000 0041 4107 01',
  'DE32 2565 0106 0000 3737 12',
  'DE24 3345 0000 0042 1508 21',
  'DE94 6006 9224 0066 7750 00',
  'DE90 3105 0000 0003 6722 68',
  'DE17 4009 0900 3986 4976 00',
  'DE25 6039 1420 0050 5500 04',
  'DE96 5489 1300 1234 5678 90',
  'DE40 7336 9920 0010 0400 62',
  'DE83 3706 0193 0016 1510 68',
  'DE57 7216 9831 0000 1507 54',
  'DE04 5506 1303 0000 0515 35',
  'DE54 7936 3151 0007 7783 09',
  'DE28 4146 0116 0000 7325 00',
  'DE34 5001 0700 0001 5481 45',
  'DE60 7206 9274 0006 4093 18',
  'DE55 7506 9110 0040 0248 48',
  'DE60 7315 0000 0810 2026 55',
  'DE28 2806 3526 0010 2113 00',
  'DE17 2586 1990 0012 3846 01',
  'DE55 7016 9383 0000 9022 09',
  'DE18 5706 9144 0002 2222 21',
  'DE46 3506 0190 1620 8810 11',
  'DE62 5305 1396 0000 0888 88',
  'DE97 5706 9806 0000 1831 77',
  'DE54 4006 9266 6010 6860 00',
  'DE46 5005 0201 0000 3698 53',
  'DE45 7206 9736 0000 0225 86',
  'DE87 7206 9329 0007 1213 18',
  'DE94 8206 4188 0003 0630 62',
  'DE63 5066 1639 1234 5678 90',
  'DE36 4006 9606 0200 6983 00',
  'DE26 8006 3558 0003 1108 00',
  'DE73 7016 9410 0002 8787 80',
  'DE85 6729 0000 0030 2259 02',
  'DE39 7215 2070 0000 0014 12',
  'DE09 1509 1704 0130 5130 85',
  'DE02 3565 0000 0000 1051 89',
  'DE75 2519 3331 3005 3404 01',
  'DE98 2309 0142 0032 3627 06',
  'DE75 5109 1700 0002 0318 09',
  'DE48 6666 1454 0000 0001 00',
  'DE78 3406 0094 0009 8351 90',
  'DE70 7605 0101 8989 3829 82',
  'DE95 2105 0170 1234 5678 90',
  'DE27 2306 3129 0000 1520 05',
  'DE92 6129 0120 0431 7280 03',
  'DE24 7336 9264 0007 1330 06',
  'DE79 7609 0900 1508 0166 00',
  'DE61 2859 1654 0012 3730 00',
  'DE56 6746 1733 0044 4577 09',
  'DE15 7436 9662 0000 0421 10',
  'DE67 6329 0110 0361 5530 05',
  'DE50 7956 7531 0002 6020 24',
  'DE79 2806 4179 0808 8080 00',
  'DE97 6006 9905 0016 2490 03',
  'DE67 4006 1238 1234 5678 90',
  'DE46 7019 0000 1234 5678 90',
  'DE21 6829 0000 0020 2191 14',
  'DE37 1606 0122 0002 0519 07',
  'DE02 5006 9976 0100 1157 03',
  'DE97 6006 9905 0016 2490 03',
  'DE32 2506 9262 0010 1389 00',
  'DE98 7905 0000 0047 3970 39',
  'DE51 3246 0422 0002 8850 18',
  'DE59 2656 2490 4807 0700 00',
  'DE66 6119 1310 0001 9700 03',
  'DE52 2916 5681 0020 3114 00',
  'DE66 7229 0100 0005 2183 14',
  'DE49 6119 0110 0031 0000 02',
  'DE61 2806 6214 0005 7720 00',
  'DE52 6746 2368 0000 1003 82',
  'DE43 5125 0000 0041 4107 01',
  'DE43 5125 0000 0041 4107 01',
  'DE82 7216 9246 0200 1035 35',
  'DE66 7206 9002 0100 3161 13',
  'DE13 7539 0000 1234 5678 90',
  'DE61 7535 0000 0000 1002 30',
  'DE50 3706 2600 3702 4250 17',
  'DE44 5909 2000 1028 3600 09',
  'DE13 6666 1329 0000 0802 84',
  'DE39 7406 9744 0000 0181 04',
  'DE94 6806 4222 0008 9100 06',
  'DE97 8209 4054 0000 5246 20',
  'DE72 2129 0016 0098 8021 60',
  'DE28 4286 1387 3544 1666 00',
  'DE79 2689 1484 0011 8150 00',
  'DE31 5606 1472 0006 7366 76',
  'DE06 8206 4038 0101 0240 51',
  'DE84 1606 1938 0005 0359 10',
  'DE02 2509 0500 0001 9228 15',
  'DE24 7016 9619 0000 6003 00',
  'DE50 7606 9512 0100 0054 01',
  'DE79 1606 2008 5101 5668 00',
  'DE68 2659 0025 0316 0408 00',
  'DE96 2109 0900 1508 0166 00',
  'DE76 6506 3086 0008 9330 06',
  'DE54 5065 0023 0000 1111 20',
  'DE57 7016 9132 0000 2404 19',
  'DE48 2919 0024 0105 1245 00',
  'DE61 7206 9179 0000 3638 71',
  'DE70 7016 9465 0000 0231 75',
  'DE15 2919 0330 0340 9074 00',
  'DE84 6626 1416 0000 0028 52',
  'DE84 6046 2808 0071 2240 09',
  'DE43 5125 0000 0041 4107 01',
  'DE02 5139 0000 0000 2826 00',
  'DE79 4506 1524 4045 4533 00',
  'DE44 2806 9956 1234 5678 90',
  'DE73 6806 3479 0021 2170 00',
  'DE38 3006 0601 0004 7806 04',
  'DE22 2806 6620 0210 5039 00',
  'DE19 6606 9342 0030 1170 00',
  'DE66 5109 1500 0001 0091 09',
  'DE12 3006 0992 1508 0166 00',
  'DE39 2105 1275 0000 0070 05',
  'DE05 7439 0000 0001 5683 10',
  'DE38 5856 0103 0004 4111 65',
  'DE96 7706 9764 0004 0105 66',
  'DE44 5306 0180 0003 0045 20',
  'DE82 6746 1424 0015 6336 03',
  'DE59 5186 1616 0000 1061 00',
  'DE75 6669 2300 1234 5678 90',
  'DE43 2515 2375 0001 0007 28',
  'DE12 2229 0031 0000 0002 80',
  'DE63 7906 9031 0000 0818 84',
  'DE39 7406 1813 1234 5678 90',
  'DE49 4016 4901 0065 5381 00',
  'DE19 5746 0117 0101 5078 31',
  'DE64 3846 2135 0014 8920 10',
  'DE33 7426 0110 0005 4008 13',
  'DE25 6846 2427 0022 0010 00',
  'DE18 7706 1004 0106 7193 68',
  'DE20 6709 2300 0006 6261 06',
  'DE78 2806 2249 0130 6006 00',
  'DE72 3016 0213 0000 0150 16',
  'DE46 4306 0967 0605 0404 00',
  'DE12 8509 5004 4435 8210 01',
  'DE69 5709 0900 1508 0166 00',
  'DE89 5501 0400 0000 2553 43',
  'DE63 6149 0150 1116 6750 05',
  'DE31 2806 1822 3030 7597 00',
  'DE92 8105 5000 3320 0000 20',
  'DE37 6936 2032 0068 2510 01',
  'DE28 6609 0800 0128 2838 83',
  'DE89 7016 6486 0000 5014 17',
  'DE90 2806 9092 2402 1369 00',
  'DE72 2166 1719 0006 1034 80',
  'DE81 7606 9468 0003 0490 00',
  'DE78 6849 2200 0002 0533 57',
  'DE79 5205 2154 0025 0009 69',
  'DE34 6136 1975 0230 5820 01',
  'DE45 3906 0180 2121 2121 21',
  'DE30 8109 3054 0002 1116 59',
  'DE33 2179 1906 0000 5963 70',
  'DE97 3106 0181 0096 6930 10',
  'DE46 5006 9126 0000 9369 10',
  'DE94 2109 2023 0013 0173 00',
  'DE18 7816 0069 0000 4002 11',
  'DE31 4909 2650 0519 9880 00',
  'DE58 7506 9171 0000 0030 00',
  'DE61 7206 2152 0100 0909 99',
  'DE25 4786 2447 0000 2516 08',
  'DE36 5625 0030 0020 0348 06',
  'DE52 5096 1592 0007 1114 01',
  'DE95 5509 1200 0010 1810 03',
  'DE66 8709 6214 0300 4593 31',
  'DE11 6006 0396 0000 5590 08',
  'DE30 6656 2300 0000 0933 60',
  'DE13 8609 5604 0307 2786 85',
  'DE42 5709 2800 0217 4353 07',
  'DE68 3755 1440 0213 0700 97',
  'DE41 5739 1800 0005 3509 13',
  'DE65 5085 2553 0016 0195 07',
  'DE32 2806 5061 0016 5255 00',
  'DE18 6009 0100 0394 2160 08',
  'DE74 2806 3253 0049 8467 00',
  'DE23 4726 0121 9022 0639 00',
  'DE86 5136 1021 0000 0248 99',
  'DE71 7919 0000 0008 9399 69',
  'DE84 7406 9768 0000 0652 00',
  'DE08 2699 1066 2222 2211 11',
  'DE50 6426 2408 1564 7710 08',
  'DE68 7956 2514 0001 4168 80',
  'DE52 8306 5408 0000 6148 66',
  'DE80 1009 0900 1508 0166 00',
  'DE71 6536 1989 0000 6320 07',
  'DE53 5225 0030 0010 0400 62',
  'DE37 5066 3699 0200 0061 65',
  'DE48 5209 0000 0180 6384 07',
  'DE54 5065 0023 0000 1111 20',
  'DE53 7306 1191 0003 2225 60',
  'DE72 1409 1464 0000 0288 00',
  'DE54 7509 0900 9752 8036 15',
  'DE26 6839 1500 0061 6474 14',
  'DE78 2806 9381 0000 0000 17',
  'DE75 2806 2165 0214 4506 00',
  'DE54 6665 0085 1234 5678 90',
  'DE20 5185 0079 0051 0000 80',
  'DE59 5929 1000 1234 5678 90',
  'DE32 5409 0000 0011 0460 02',
  'DE56 2789 3760 1001 8484 00',
  'DE76 4726 2703 0200 0848 00',
  'DE88 3706 9720 2302 7930 29',
  'DE08 6309 1300 0000 6960 05',
  'DE08 2666 1380 0000 1856 00',
  'DE93 2859 0075 6000 9160 00',
  'DE03 7509 0500 0000 7507 50',
  'DE20 7005 3070 0008 0072 21',
  'DE62 7009 3400 0000 0012 60',
  'DE85 7016 9333 0000 8161 40',
  'DE38 2189 0022 0002 0199 73',
  'DE21 6049 0150 0480 9740 04',
  'DE67 7016 3370 0303 2750 00',
  'DE87 8206 4088 0002 5051 00',
  'DE03 6126 1339 0006 1610 06',
  'DE36 6439 0130 0001 5620 02',
  'DE17 4476 1534 3002 9162 00',
  'DE77 7916 1499 0000 2476 34',
  'DE26 8409 4814 0000 0000 42',
  'DE06 2006 9177 0000 2053 20',
  'DE46 2135 2240 0091 5215 42',
  'DE79 2806 5108 0010 0056 00',
  'DE71 6066 3084 0058 1100 03',
  'DE70 1004 0062 0010 0400 62',
  'DE56 2009 0900 2450 7986 00',
  'DE78 6639 1200 0000 0647 50',
  'DE20 6609 0900 7447 6600 22',
  'DE16 2709 0900 0010 0909 00',
  'DE35 7016 9186 0000 0331 11',
  'DE33 7316 0000 0006 4962 02',
  'DE29 7216 9756 0000 0248 56',
  'DE57 2169 0020 0008 2142 39',
  'DE73 3206 0362 0130 8090 14',
  'DE87 5032 0600 0000 0000 00',
  'DE24 6039 1310 0451 6120 00',
  'DE49 6139 1410 1234 5678 90',
  'DE02 4246 1435 5401 9217 00',
  'DE27 3706 9125 2122 2790 25',
  'DE17 4416 0014 6441 1220 00',
  'DE94 3546 1106 0000 0001 00',
  'DE75 6729 2200 0067 5013 06',
  'DE27 7012 0400 7111 5910 17',
  'DE61 7906 9010 0007 1331 03',
  'DE55 2666 1494 8514 0104 00',
  'DE81 3586 0245 5202 6640 18',
  'DE15 5056 1315 0003 6051 08',
  'DE38 6149 1010 0210 9670 13',
  'DE46 6006 9378 0055 6430 00',
  'DE44 7526 1700 0000 6298 80',
  'DE57 8709 5974 0000 0237 44',
  'DE97 6746 0041 0020 7933 09',
  'DE68 7606 9449 0006 4860 02',
  'DE41 2805 0100 0000 4233 01',
  'DE76 6725 0020 0009 0543 67',
  'DE18 4606 0040 0666 6663 00',
  'DE97 5235 0005 0010 0400 62',
  'DE45 7606 9564 0000 0020 54',
  'DE28 3056 0548 3011 7870 36',
  'DE45 6839 0000 0000 1762 06',
  'DE93 6809 0000 0030 6486 09',
  'DE26 6429 1420 0020 2430 06',
  'DE97 6806 1505 0052 6537 03',
  'DE33 7606 1482 0105 0368 44',
  'DE30 5856 1771 0000 1593 53',
  'DE31 7209 0000 0007 1036 97',
  'DE63 2806 1410 0011 4413 00',
  'DE51 8609 5554 0176 7056 47',
  'DE67 5509 0500 0001 3269 21',
  'DE53 8706 9077 0091 0172 02',
  'DE98 2179 1805 0000 0241 63',
  'DE73 2826 2254 5064 1350 09',
  'DE81 2006 9861 0000 1127 39',
  'DE52 5206 4156 0000 0711 10',
  'DE39 3101 0833 9902 9162 68',
  'DE66 2806 9109 0029 8883 00',
  'DE53 5009 3000 0001 2140 04',
  'DE69 8509 4984 0012 0989 01',
  'DE95 4126 2501 3427 8385 01',
  'DE67 7506 9014 0006 6237 00',
  'DE62 7009 3200 1234 5678 90',
  'DE05 4666 0022 0504 0837 00',
  'DE77 7016 9614 0002 5225 19',
  'DE54 5065 0023 0000 1111 20',
  'DE28 7906 9150 0108 8555 87',
  'DE20 6406 1854 0602 1830 06',
  'DE16 2656 5928 0011 5622 00',
  'DE72 3506 0386 4717 8300 00',
  'DE71 4286 1814 0045 5005 00',
  'DE42 7656 0060 0123 4567 89',
  'DE58 2555 1480 0470 1404 01',
  'DE29 6409 0100 0101 6300 00',
  'DE82 7209 0900 1508 0166 00',
  'DE44 7206 9043 0000 8000 66',
  'DE39 2806 9773 0022 0914 00',
  'DE23 2666 0060 0000 6254 00',
  'DE70 5766 2263 0000 0001 00',
  'DE37 7806 0896 0207 7114 41',
  'DE22 7436 9130 0000 2156 86',
  'DE59 4506 0009 0170 0156 00',
  'DE38 7016 9524 0000 0612 12',
  'DE38 2566 3584 0015 1807 05',
  'DE88 7606 9440 0000 5730 60',
  'DE63 1406 1308 1234 5678 90',
  'DE18 6739 0000 0000 0770 38',
  'DE76 2176 3542 0006 1607 00',
  'DE61 2806 7170 0561 2977 00',
  'DE65 5006 9345 0004 1915 36',
  'DE43 4286 1608 0082 2223 00',
  'DE70 2806 9991 0022 1112 00',
  'DE75 2109 0007 0088 4441 04',
  'DE38 2856 2297 7200 8008 00',
  'DE26 7336 9823 0000 2105 28',
  'DE36 2139 2218 0000 0007 60',
  'DE33 5075 0094 0000 0521 99',
  'DE87 6806 2105 0000 5413 03',
  'DE38 7016 9450 0002 5101 11',
  'DE55 4785 3520 0003 0104 77',
  'DE07 4786 0125 0001 4007 00',
  'DE98 4036 1906 0501 2553 02',
  'DE38 6229 0110 0220 5120 00',
  'DE95 6409 1200 0042 5120 00',
  'DE20 6239 1420 0028 1320 09',
  'DE78 7506 9015 1234 5678 90',
  'DE09 7935 1010 0000 0100 09',
  'DE39 7509 0300 0007 6242 04',
  'DE86 6009 0300 0458 7700 27',
  'DE97 5776 1591 1234 5678 90',
  'DE42 2599 1528 5000 1558 00',
  'DE37 7016 9566 0007 1143 70',
  'DE15 1009 0000 5335 3120 09',
  'DE80 2019 0003 0060 0012 08',
  'DE65 2006 9800 0077 5290 00',
  'DE24 2146 4671 0000 0314 37',
  'DE17 2306 1220 0001 6913 17',
  'DE36 8106 3238 0005 0999 94',
  'DE33 4726 1603 9920 3114 00',
  'DE60 2415 1005 0000 0010 99',
  'DE15 6649 2700 1234 5678 90',
  'DE70 4016 4024 0100 4003 00',
  'DE34 6429 1010 0067 3580 04',
  'DE66 7606 9611 0000 0465 15',
  'DE40 2806 0228 0007 6627 00',
  'DE44 6649 0000 0020 0030 06',
  'DE23 2856 2716 0052 1728 00',
  'DE36 7429 0000 0000 4425 00',
  'DE88 7606 9462 0004 4611 00',
  'DE59 4286 2451 0106 6669 00',
  'DE73 7416 1608 0000 0599 27',
  'DE25 8559 1000 4530 5571 09',
  'DE35 4036 1627 0001 6686 00',
  'DE32 7906 9165 0007 1300 07',
  'DE29 2019 0109 0010 0462 00',
  'DE62 7436 2663 0405 7920 29',
  'DE94 5329 0000 0001 0631 70',
  'DE29 5086 3513 0004 0046 20',
  'DE76 3862 1500 0000 0106 39',
  'DE92 2606 1291 0020 0030 06',
  'DE73 8006 3628 0101 1161 00',
  'DE40 5226 0385 0008 6138 26',
  'DE08 5206 9029 0000 2633 20',
  'DE38 5176 2434 0025 7500 04',
  'DE75 5306 2350 0003 2049 28',
  'DE19 2806 9926 1201 0146 00',
  'DE06 4606 2817 0013 0008 00',
  'DE12 4906 0127 0973 2291 01',
  'DE14 7439 1300 0000 0213 18',
  'DE80 5706 9238 0000 0191 58',
  'DE11 7439 2300 0000 1354 29',
  'DE18 5186 1403 0000 1100 00',
  'DE08 7016 9509 0003 2439 90',
  'DE78 2219 1405 1234 5678 90',
  'DE48 4016 5366 0105 1053 01',
  'DE78 6519 1500 0100 4350 17',
  'DE92 2006 9144 0000 4180 13',
  'DE37 6539 0120 0040 2300 07',
  'DE17 3706 9627 5600 6260 10',
  'DE43 1506 1638 0000 0004 26',
  'DE59 1809 2744 0001 0916 54',
  'DE47 2806 1679 3600 1473 01',
  'DE59 5206 0410 0000 6174 15',
  'DE41 5206 9519 0006 8723 52',
  'DE93 6006 9462 1234 5678 90',
  'DE28 7016 9543 0000 2014 99',
  'DE34 7529 0000 0000 0601 00',
  'DE56 2012 0100 1000 4400 00',
  'DE32 7646 0015 0001 9999 90',
  'DE40 5876 0954 0100 7060 54',
  'DE40 2806 9052 0227 1010 00',
  'DE38 7536 2039 0200 7013 43',
  'DE79 6209 1600 0065 8830 04',
  'DE61 2406 0300 4100 1001 00',
  'DE59 5609 0000 1234 5678 90',
  'DE74 6809 2000 0015 9023 02',
  'DE36 6209 1800 0328 4710 20',
  'DE57 7116 0000 0001 0739 82',
  'DE04 6509 1040 0008 7010 08',
  'DE36 5335 0000 0010 0057 44',
  'DE71 6949 0000 0003 1122 09',
  'DE98 2216 3114 0000 4036 79',
  'DE12 7509 0000 0100 4626 67',
  'DE57 7436 4689 0002 5429 00',
  'DE69 5939 3000 0109 1161 14',
  'DE64 8309 4494 0000 2905 80',
  'DE98 2419 1015 1004 9266 00',
  'DE49 5065 2124 0138 2325 82',
  'DE72 7436 9704 0003 4132 68',
  'DE40 7606 9576 0000 0576 22',
  'DE15 3706 9520 6600 0280 12',
  'DE80 7836 0000 0003 9770 30',
  'DE95 5089 0000 0070 0374 40',
  'DE28 2559 1413 0071 4550 00',
  'DE97 6309 0100 0733 8500 06',
  'DE14 7706 9461 0106 7433 90',
  'DE26 7906 3060 0000 0261 23',
  'DE23 7621 1900 0005 0001 14',
  'DE34 7336 9821 0000 4385 29',
  'DE27 7709 1800 0000 9144 44',
  'DE59 2139 0008 0000 7500 00',
  'DE74 6809 2000 0015 9023 02',
  'DE50 5009 0900 1508 0166 00',
  'DE68 5019 0000 0000 1410 11',
  'DE48 7206 9155 0000 5002 08',
  'DE66 3706 0993 1508 0166 00',
  'DE51 6506 2577 0800 6140 03',
  'DE10 6116 1696 0677 1840 00',
  'DE47 3126 3359 5705 6400 19',
  'DE32 5023 4500 1234 5678 90',
  'DE40 2916 2394 0005 0008 00',
  'DE64 6546 1878 0050 1310 01',
  'DE73 6729 1700 0044 9553 00',
  'DE67 6106 0500 0123 4567 89',
  'DE65 2836 1592 0083 7008 00',
  'DE64 7506 9061 0000 6349 99',
  'DE27 5519 0000 0015 0900 12',
  'DE06 7016 9605 0004 0013 54',
  'DE94 7106 1009 0000 7030 44',
  'DE91 2569 1633 4227 3641 00',
  'DE34 5006 1741 0000 4670 22',
  'DE35 7706 2139 0000 0673 34',
  'DE97 2806 9706 0010 0960 00',
  'DE96 6206 3263 0015 2470 07',
  'DE69 6436 1359 0086 2840 02',
  'DE49 4806 2051 0102 9673 00',
  'DE53 7719 0000 0000 3238 10',
  'DE59 5206 3369 1233 9120 08',
  'DE69 4406 0122 4019 0005 00',
  'DE91 6009 0900 1508 0166 00',
  'DE15 5866 0101 0006 6004 37',
  'DE14 2702 0001 1501 7728 40',
  'DE31 7406 1101 0000 0805 27',
  'DE16 4949 0070 0000 8803 00',
  'DE36 7216 0818 1234 5678 90',
  'DE52 7016 9598 0000 0561 70',
  'DE94 5205 1877 0000 0259 08',
  'DE73 2519 0001 0176 0106 00',
  'DE23 7009 1500 1234 5678 90',
  'DE19 6536 2499 0074 2130 08',
  'DE79 7339 0000 0000 0612 12',
  'DE72 6426 1363 0043 6100 05',
  'DE77 5122 0700 1020 7040 50',
  'DE42 6006 9553 0090 7710 01',
  'DE46 8559 0100 4559 0323 07',
  'DE96 7319 0000 0000 1131 82',
  'DE33 7333 1700 0013 0012 11',
  'DE94 2806 2560 0007 1129 00',
  'DE81 3706 9642 1234 5678 90',
  'DE55 8009 3574 0001 2556 65',
  'DE48 6669 0000 0003 0261 95',
  'DE97 2702 0000 0016 4099 10',
];

export const Chars = (() => {
  const c = {};
  c['l'] = 'abcdefghijklmnoprstuvwxyz';
  c['U'] = c['l'].toUpperCase();
  c['v'] = 'aeiouy';
  c['V'] = c['v'].toUpperCase();
  c['c'] = 'bcdfghjklmnprstvwxz';
  c['C'] = c['c'].toUpperCase();
  c['9'] = '0123456789';
  c['#'] = '!@#$%^&*_-+=()[]{}';
  c['a'] = c['l'] + c['9'];
  c['A'] = c['a'].toUpperCase();
  c[' '] = ' ';
  return c;
})();

// Please, for any amazing man that you add to the list, consider adding an equally amazing woman to it, and vice versa.
export const Names = [
  // Muhammad ibn Jābir al-Ḥarrānī al-Battānī was a founding father of astronomy. https://en.wikipedia.org/wiki/Mu%E1%B8%A5ammad_ibn_J%C4%81bir_al-%E1%B8%A4arr%C4%81n%C4%AB_al-Batt%C4%81n%C4%AB
  'albattani',

  // Frances E. Allen, became the first female IBM Fellow in 1989. In 2006, she became the first female recipient of the ACM's Turing Award. https://en.wikipedia.org/wiki/Frances_E._Allen
  'allen',

  // June Almeida - Scottish virologist who took the first pictures of the rubella virus - https://en.wikipedia.org/wiki/June_Almeida
  'almeida',

  // Maria Gaetana Agnesi - Italian mathematician, philosopher, theologian and humanitarian. She was the first woman to write a mathematics handbook and the first woman appointed as a Mathematics Professor at a University. https://en.wikipedia.org/wiki/Maria_Gaetana_Agnesi
  'agnesi',

  // Archimedes was a physicist, engineer and mathematician who invented too many things to list them here. https://en.wikipedia.org/wiki/Archimedes
  'archimedes',

  // Maria Ardinghelli - Italian translator, mathematician and physicist - https://en.wikipedia.org/wiki/Maria_Ardinghelli
  'ardinghelli',

  // Aryabhata - Ancient Indian mathematician-astronomer during 476-550 CE https://en.wikipedia.org/wiki/Aryabhata
  'aryabhata',

  // Wanda Austin - Wanda Austin is the President and CEO of The Aerospace Corporation, a leading architect for the US security space programs. https://en.wikipedia.org/wiki/Wanda_Austin
  'austin',

  // Charles Babbage invented the concept of a programmable computer. https://en.wikipedia.org/wiki/Charles_Babbage.
  'babbage',

  // Stefan Banach - Polish mathematician, was one of the founders of modern functional analysis. https://en.wikipedia.org/wiki/Stefan_Banach
  'banach',

  // John Bardeen co-invented the transistor - https://en.wikipedia.org/wiki/John_Bardeen
  'bardeen',

  // Jean Bartik, born Betty Jean Jennings, was one of the original programmers for the ENIAC computer. https://en.wikipedia.org/wiki/Jean_Bartik
  'bartik',

  // Laura Bassi, the world's first female professor https://en.wikipedia.org/wiki/Laura_Bassi
  'bassi',

  // Alexander Graham Bell - an eminent Scottish-born scientist, inventor, engineer and innovator who is credited with inventing the first practical telephone - https://en.wikipedia.org/wiki/Alexander_Graham_Bell
  'bell',

  // Homi J Bhabha - was an Indian nuclear physicist, founding director, and professor of physics at the Tata Institute of Fundamental Research. Colloquially known as 'father of Indian nuclear programme'- https://en.wikipedia.org/wiki/Homi_J._Bhabha
  'bhabha',

  // Bhaskara II - Ancient Indian mathematician-astronomer whose work on calculus predates Newton and Leibniz by over half a millennium - https://en.wikipedia.org/wiki/Bh%C4%81skara_II#Calculus
  'bhaskara',

  // Elizabeth Blackwell - American doctor and first American woman to receive a medical degree - https://en.wikipedia.org/wiki/Elizabeth_Blackwell
  'blackwell',

  // Niels Bohr is the father of quantum theory. https://en.wikipedia.org/wiki/Niels_Bohr.
  'bohr',

  // Kathleen Booth, she's credited with writing the first assembly language. https://en.wikipedia.org/wiki/Kathleen_Booth
  'booth',

  // Anita Borg - Anita Borg was the founding director of the Institute for Women and Technology (IWT). https://en.wikipedia.org/wiki/Anita_Borg
  'borg',

  // Satyendra Nath Bose - He provided the foundation for Bose–Einstein statistics and the theory of the Bose–Einstein condensate. - https://en.wikipedia.org/wiki/Satyendra_Nath_Bose
  'bose',

  // Evelyn Boyd Granville - She was one of the first African-American woman to receive a Ph.D. in mathematics; she earned it in 1949 from Yale University. https://en.wikipedia.org/wiki/Evelyn_Boyd_Granville
  'boyd',

  // Brahmagupta - Ancient Indian mathematician during 598-670 CE who gave rules to compute with zero - https://en.wikipedia.org/wiki/Brahmagupta#Zero
  'brahmagupta',

  // Walter Houser Brattain co-invented the transistor - https://en.wikipedia.org/wiki/Walter_Houser_Brattain
  'brattain',

  // Emmett Brown invented time travel. https://en.wikipedia.org/wiki/Emmett_Brown (thanks Brian Goff)
  'brown',

  // Rachel Carson - American marine biologist and conservationist, her book Silent Spring and other writings are credited with advancing the global environmental movement. https://en.wikipedia.org/wiki/Rachel_Carson
  'carson',

  // Subrahmanyan Chandrasekhar - Astrophysicist known for his mathematical theory on different stages and evolution in structures of the stars. He has won nobel prize for physics - https://en.wikipedia.org/wiki/Subrahmanyan_Chandrasekhar
  'chandrasekhar',

  //Claude Shannon - The father of information theory and founder of digital circuit design theory. (https://en.wikipedia.org/wiki/Claude_Shannon)
  'shannon',

  // Jane Colden - American botanist widely considered the first female American botanist - https://en.wikipedia.org/wiki/Jane_Colden
  'colden',

  // Gerty Theresa Cori - American biochemist who became the third woman—and first American woman—to win a Nobel Prize in science, and the first woman to be awarded the Nobel Prize in Physiology or Medicine. Cori was born in Prague. https://en.wikipedia.org/wiki/Gerty_Cori
  'cori',

  // Seymour Roger Cray was an American electrical engineer and supercomputer architect who designed a series of computers that were the fastest in the world for decades. https://en.wikipedia.org/wiki/Seymour_Cray
  'cray',

  // This entry reflects a husband and wife team who worked together:
  // Joan Curran was a Welsh scientist who developed radar and invented chaff, a radar countermeasure. https://en.wikipedia.org/wiki/Joan_Curran
  // Samuel Curran was an Irish physicist who worked alongside his wife during WWII and invented the proximity fuse. https://en.wikipedia.org/wiki/Samuel_Curran
  'curran',

  // Marie Curie discovered radioactivity. https://en.wikipedia.org/wiki/Marie_Curie.
  'curie',

  // Charles Darwin established the principles of natural evolution. https://en.wikipedia.org/wiki/Charles_Darwin.
  'darwin',

  // Leonardo Da Vinci invented too many things to list here. https://en.wikipedia.org/wiki/Leonardo_da_Vinci.
  'davinci',

  // Edsger Wybe Dijkstra was a Dutch computer scientist and mathematical scientist. https://en.wikipedia.org/wiki/Edsger_W._Dijkstra.
  'dijkstra',

  // Donna Dubinsky - played an integral role in the development of personal digital assistants (PDAs) serving as CEO of Palm, Inc. and co-founding Handspring. https://en.wikipedia.org/wiki/Donna_Dubinsky
  'dubinsky',

  // Annie Easley - She was a leading member of the team which developed software for the Centaur rocket stage and one of the first African-Americans in her field. https://en.wikipedia.org/wiki/Annie_Easley
  'easley',

  // Thomas Alva Edison, prolific inventor https://en.wikipedia.org/wiki/Thomas_Edison
  'edison',

  // Albert Einstein invented the general theory of relativity. https://en.wikipedia.org/wiki/Albert_Einstein
  'einstein',

  // Gertrude Elion - American biochemist, pharmacologist and the 1988 recipient of the Nobel Prize in Medicine - https://en.wikipedia.org/wiki/Gertrude_Elion
  'elion',

  // Douglas Engelbart gave the mother of all demos: https://en.wikipedia.org/wiki/Douglas_Engelbart
  'engelbart',

  // Euclid invented geometry. https://en.wikipedia.org/wiki/Euclid
  'euclid',

  // Leonhard Euler invented large parts of modern mathematics. https://de.wikipedia.org/wiki/Leonhard_Euler
  'euler',

  // Pierre de Fermat pioneered several aspects of modern mathematics. https://en.wikipedia.org/wiki/Pierre_de_Fermat
  'fermat',

  // Enrico Fermi invented the first nuclear reactor. https://en.wikipedia.org/wiki/Enrico_Fermi.
  'fermi',

  // Richard Feynman was a key contributor to quantum mechanics and particle physics. https://en.wikipedia.org/wiki/Richard_Feynman
  'feynman',

  // Benjamin Franklin is famous for his experiments in electricity and the invention of the lightning rod.
  'franklin',

  // Galileo was a founding father of modern astronomy, and faced politics and obscurantism to establish scientific truth.  https://en.wikipedia.org/wiki/Galileo_Galilei
  'galileo',

  // William Henry 'Bill' Gates III is an American business magnate, philanthropist, investor, computer programmer, and inventor. https://en.wikipedia.org/wiki/Bill_Gates
  'gates',

  // Adele Goldberg, was one of the designers and developers of the Smalltalk language. https://en.wikipedia.org/wiki/Adele_Goldberg_(computer_scientist)
  'goldberg',

  // Adele Goldstine, born Adele Katz, wrote the complete technical description for the first electronic digital computer, ENIAC. https://en.wikipedia.org/wiki/Adele_Goldstine
  'goldstine',

  // Shafi Goldwasser is a computer scientist known for creating theoretical foundations of modern cryptography. Winner of 2012 ACM Turing Award. https://en.wikipedia.org/wiki/Shafi_Goldwasser
  'goldwasser',

  // James Golick, all around gangster.
  'golick',

  // Jane Goodall - British primatologist, ethologist, and anthropologist who is considered to be the world's foremost expert on chimpanzees - https://en.wikipedia.org/wiki/Jane_Goodall
  'goodall',

  // Margaret Hamilton - Director of the Software Engineering Division of the MIT Instrumentation Laboratory, which developed on-board flight software for the Apollo space program. https://en.wikipedia.org/wiki/Margaret_Hamilton_(scientist)
  'hamilton',

  // Stephen Hawking pioneered the field of cosmology by combining general relativity and quantum mechanics. https://en.wikipedia.org/wiki/Stephen_Hawking
  'hawking',

  // Werner Heisenberg was a founding father of quantum mechanics. https://en.wikipedia.org/wiki/Werner_Heisenberg
  'heisenberg',

  // Jaroslav Heyrovský was the inventor of the polarographic method, father of the electroanalytical method, and recipient of the Nobel Prize in 1959. His main field of work was polarography. https://en.wikipedia.org/wiki/Jaroslav_Heyrovsk%C3%BD
  'heyrovsky',

  // Dorothy Hodgkin was a British biochemist, credited with the development of protein crystallography. She was awarded the Nobel Prize in Chemistry in 1964. https://en.wikipedia.org/wiki/Dorothy_Hodgkin
  'hodgkin',

  // Erna Schneider Hoover revolutionized modern communication by inventing a computerized telephone switching method. https://en.wikipedia.org/wiki/Erna_Schneider_Hoover
  'hoover',

  // Grace Hopper developed the first compiler for a computer programming language and  is credited with popularizing the term 'debugging' for fixing computer glitches. https://en.wikipedia.org/wiki/Grace_Hopper
  'hopper',

  // Frances Hugle, she was an American scientist, engineer, and inventor who contributed to the understanding of semiconductors, integrated circuitry, and the unique electrical principles of microscopic materials. https://en.wikipedia.org/wiki/Frances_Hugle
  'hugle',

  // Hypatia - Greek Alexandrine Neoplatonist philosopher in Egypt who was one of the earliest mothers of mathematics - https://en.wikipedia.org/wiki/Hypatia
  'hypatia',

  // Yeong-Sil Jang was a Korean scientist and astronomer during the Joseon Dynasty; he invented the first metal printing press and water gauge. https://en.wikipedia.org/wiki/Jang_Yeong-sil
  'jang',

  // Betty Jennings - one of the original programmers of the ENIAC. https://en.wikipedia.org/wiki/ENIAC - https://en.wikipedia.org/wiki/Jean_Bartik
  'jennings',

  // Mary Lou Jepsen, was the founder and chief technology officer of One Laptop Per Child (OLPC), and the founder of Pixel Qi. https://en.wikipedia.org/wiki/Mary_Lou_Jepsen
  'jepsen',

  // Irène Joliot-Curie - French scientist who was awarded the Nobel Prize for Chemistry in 1935. Daughter of Marie and Pierre Curie. https://en.wikipedia.org/wiki/Ir%C3%A8ne_Joliot-Curie
  'joliot',

  // Karen Spärck Jones came up with the concept of inverse document frequency, which is used in most search engines today. https://en.wikipedia.org/wiki/Karen_Sp%C3%A4rck_Jones
  'jones',

  // A. P. J. Abdul Kalam - is an Indian scientist aka Missile Man of India for his work on the development of ballistic missile and launch vehicle technology - https://en.wikipedia.org/wiki/A._P._J._Abdul_Kalam
  'kalam',

  // Susan Kare, created the icons and many of the interface elements for the original Apple Macintosh in the 1980s, and was an original employee of NeXT, working as the Creative Director. https://en.wikipedia.org/wiki/Susan_Kare
  'kare',

  // Mary Kenneth Keller, Sister Mary Kenneth Keller became the first American woman to earn a PhD in Computer Science in 1965. https://en.wikipedia.org/wiki/Mary_Kenneth_Keller
  'keller',

  // Har Gobind Khorana - Indian-American biochemist who shared the 1968 Nobel Prize for Physiology - https://en.wikipedia.org/wiki/Har_Gobind_Khorana
  'khorana',

  // Jack Kilby invented silicone integrated circuits and gave Silicon Valley its name. - https://en.wikipedia.org/wiki/Jack_Kilby
  'kilby',

  // Maria Kirch - German astronomer and first woman to discover a comet - https://en.wikipedia.org/wiki/Maria_Margarethe_Kirch
  'kirch',

  // Donald Knuth - American computer scientist, author of 'The Art of Computer Programming' and creator of the TeX typesetting system. https://en.wikipedia.org/wiki/Donald_Knuth
  'knuth',

  // Sophie Kowalevski - Russian mathematician responsible for important original contributions to analysis, differential equations and mechanics - https://en.wikipedia.org/wiki/Sofia_Kovalevskaya
  'kowalevski',

  // Marie-Jeanne de Lalande - French astronomer, mathematician and cataloguer of stars - https://en.wikipedia.org/wiki/Marie-Jeanne_de_Lalande
  'lalande',

  // Hedy Lamarr - Actress and inventor. The principles of her work are now incorporated into modern Wi-Fi, CDMA and Bluetooth technology. https://en.wikipedia.org/wiki/Hedy_Lamarr
  'lamarr',

  // Leslie B. Lamport - American computer scientist. Lamport is best known for his seminal work in distributed systems and was the winner of the 2013 Turing Award. https://en.wikipedia.org/wiki/Leslie_Lamport
  'lamport',

  // Mary Leakey - British paleoanthropologist who discovered the first fossilized Proconsul skull - https://en.wikipedia.org/wiki/Mary_Leakey
  'leakey',

  // Henrietta Swan Leavitt - she was an American astronomer who discovered the relation between the luminosity and the period of Cepheid variable stars. https://en.wikipedia.org/wiki/Henrietta_Swan_Leavitt
  'leavitt',

  // Ruth Lichterman - one of the original programmers of the ENIAC. https://en.wikipedia.org/wiki/ENIAC - https://en.wikipedia.org/wiki/Ruth_Teitelbaum
  'lichterman',

  // Barbara Liskov - co-developed the Liskov substitution principle. Liskov was also the winner of the Turing Prize in 2008. - https://en.wikipedia.org/wiki/Barbara_Liskov
  'liskov',

  // Ada Lovelace invented the first algorithm. https://en.wikipedia.org/wiki/Ada_Lovelace (thanks James Turnbull)
  'lovelace',

  // Auguste and Louis Lumière - the first filmmakers in history - https://en.wikipedia.org/wiki/Auguste_and_Louis_Lumi%C3%A8re
  'lumiere',

  // Mahavira - Ancient Indian mathematician during 9th century AD who discovered basic algebraic identities - https://en.wikipedia.org/wiki/Mah%C4%81v%C4%ABra_(mathematician)
  'mahavira',

  // Maria Mayer - American theoretical physicist and Nobel laureate in Physics for proposing the nuclear shell model of the atomic nucleus - https://en.wikipedia.org/wiki/Maria_Mayer
  'mayer',

  // John McCarthy invented LISP: https://en.wikipedia.org/wiki/John_McCarthy_(computer_scientist)
  'mccarthy',

  // Barbara McClintock - a distinguished American cytogeneticist, 1983 Nobel Laureate in Physiology or Medicine for discovering transposons. https://en.wikipedia.org/wiki/Barbara_McClintock
  'mcclintock',

  // Malcolm McLean invented the modern shipping container: https://en.wikipedia.org/wiki/Malcom_McLean
  'mclean',

  // Kay McNulty - one of the original programmers of the ENIAC. https://en.wikipedia.org/wiki/ENIAC - https://en.wikipedia.org/wiki/Kathleen_Antonelli
  'mcnulty',

  // Lise Meitner - Austrian/Swedish physicist who was involved in the discovery of nuclear fission. The element meitnerium is named after her - https://en.wikipedia.org/wiki/Lise_Meitner
  'meitner',

  // Carla Meninsky, was the game designer and programmer for Atari 2600 games Dodge 'Em and Warlords. https://en.wikipedia.org/wiki/Carla_Meninsky
  'meninsky',

  // Johanna Mestorf - German prehistoric archaeologist and first female museum director in Germany - https://en.wikipedia.org/wiki/Johanna_Mestorf
  'mestorf',

  // Marvin Minsky - Pioneer in Artificial Intelligence, co-founder of the MIT's AI Lab, won the Turing Award in 1969. https://en.wikipedia.org/wiki/Marvin_Minsky
  'minsky',

  // Maryam Mirzakhani - an Iranian mathematician and the first woman to win the Fields Medal. https://en.wikipedia.org/wiki/Maryam_Mirzakhani
  'mirzakhani',

  // Samuel Morse - contributed to the invention of a single-wire telegraph system based on European telegraphs and was a co-developer of the Morse code - https://en.wikipedia.org/wiki/Samuel_Morse
  'morse',

  // Ian Murdock - founder of the Debian project - https://en.wikipedia.org/wiki/Ian_Murdock
  'murdock',

  // Isaac Newton invented classic mechanics and modern optics. https://en.wikipedia.org/wiki/Isaac_Newton
  'newton',

  // Florence Nightingale, more prominently known as a nurse, was also the first female member of the Royal Statistical Society and a pioneer in statistical graphics https://en.wikipedia.org/wiki/Florence_Nightingale#Statistics_and_sanitary_reform
  'nightingale',

  // Alfred Nobel - a Swedish chemist, engineer, innovator, and armaments manufacturer (inventor of dynamite) - https://en.wikipedia.org/wiki/Alfred_Nobel
  'nobel',

  // Emmy Noether, German mathematician. Noether's Theorem is named after her. https://en.wikipedia.org/wiki/Emmy_Noether
  'noether',

  // Poppy Northcutt. Poppy Northcutt was the first woman to work as part of NASA’s Mission Control. http://www.businessinsider.com/poppy-northcutt-helped-apollo-astronauts-2014-12?op=1
  'northcutt',

  // Robert Noyce invented silicone integrated circuits and gave Silicon Valley its name. - https://en.wikipedia.org/wiki/Robert_Noyce
  'noyce',

  // Panini - Ancient Indian linguist and grammarian from 4th century CE who worked on the world's first formal system - https://en.wikipedia.org/wiki/P%C4%81%E1%B9%87ini#Comparison_with_modern_formal_systems
  'panini',

  // Ambroise Pare invented modern surgery. https://en.wikipedia.org/wiki/Ambroise_Par%C3%A9
  'pare',

  // Louis Pasteur discovered vaccination, fermentation and pasteurization. https://en.wikipedia.org/wiki/Louis_Pasteur.
  'pasteur',

  // Cecilia Payne-Gaposchkin was an astronomer and astrophysicist who, in 1925, proposed in her Ph.D. thesis an explanation for the composition of stars in terms of the relative abundances of hydrogen and helium. https://en.wikipedia.org/wiki/Cecilia_Payne-Gaposchkin
  'payne',

  // Radia Perlman is a software designer and network engineer and most famous for her invention of the spanning-tree protocol (STP). https://en.wikipedia.org/wiki/Radia_Perlman
  'perlman',

  // Rob Pike was a key contributor to Unix, Plan 9, the X graphic system, utf-8, and the Go programming language. https://en.wikipedia.org/wiki/Rob_Pike
  'pike',

  // Henri Poincaré made fundamental contributions in several fields of mathematics. https://en.wikipedia.org/wiki/Henri_Poincar%C3%A9
  'poincare',

  // Laura Poitras is a director and producer whose work, made possible by open source crypto tools, advances the causes of truth and freedom of information by reporting disclosures by whistleblowers such as Edward Snowden. https://en.wikipedia.org/wiki/Laura_Poitras
  'poitras',

  // Claudius Ptolemy - a Greco-Egyptian writer of Alexandria, known as a mathematician, astronomer, geographer, astrologer, and poet of a single epigram in the Greek Anthology - https://en.wikipedia.org/wiki/Ptolemy
  'ptolemy',

  // C. V. Raman - Indian physicist who won the Nobel Prize in 1930 for proposing the Raman effect. - https://en.wikipedia.org/wiki/C._V._Raman
  'raman',

  // Srinivasa Ramanujan - Indian mathematician and autodidact who made extraordinary contributions to mathematical analysis, number theory, infinite series, and continued fractions. - https://en.wikipedia.org/wiki/Srinivasa_Ramanujan
  'ramanujan',

  // Sally Kristen Ride was an American physicist and astronaut. She was the first American woman in space, and the youngest American astronaut. https://en.wikipedia.org/wiki/Sally_Ride
  'ride',

  // Rita Levi-Montalcini - Won Nobel Prize in Physiology or Medicine jointly with colleague Stanley Cohen for the discovery of nerve growth factor (https://en.wikipedia.org/wiki/Rita_Levi-Montalcini)
  'montalcini',

  // Dennis Ritchie - co-creator of UNIX and the C programming language. - https://en.wikipedia.org/wiki/Dennis_Ritchie
  'ritchie',

  // Wilhelm Conrad Röntgen - German physicist who was awarded the first Nobel Prize in Physics in 1901 for the discovery of X-rays (Röntgen rays). https://en.wikipedia.org/wiki/Wilhelm_R%C3%B6ntgen
  'roentgen',

  // Rosalind Franklin - British biophysicist and X-ray crystallographer whose research was critical to the understanding of DNA - https://en.wikipedia.org/wiki/Rosalind_Franklin
  'rosalind',

  // Meghnad Saha - Indian astrophysicist best known for his development of the Saha equation, used to describe chemical and physical conditions in stars - https://en.wikipedia.org/wiki/Meghnad_Saha
  'saha',

  // Jean E. Sammet developed FORMAC, the first widely used computer language for symbolic manipulation of mathematical formulas. https://en.wikipedia.org/wiki/Jean_E._Sammet
  'sammet',

  // Carol Shaw - Originally an Atari employee, Carol Shaw is said to be the first female video game designer. https://en.wikipedia.org/wiki/Carol_Shaw_(video_game_designer)
  'shaw',

  // Dame Stephanie 'Steve' Shirley - Founded a software company in 1962 employing women working from home. https://en.wikipedia.org/wiki/Steve_Shirley
  'shirley',

  // William Shockley co-invented the transistor - https://en.wikipedia.org/wiki/William_Shockley
  'shockley',

  // Françoise Barré-Sinoussi - French virologist and Nobel Prize Laureate in Physiology or Medicine; her work was fundamental in identifying HIV as the cause of AIDS. https://en.wikipedia.org/wiki/Fran%C3%A7oise_Barr%C3%A9-Sinoussi
  'sinoussi',

  // Betty Snyder - one of the original programmers of the ENIAC. https://en.wikipedia.org/wiki/ENIAC - https://en.wikipedia.org/wiki/Betty_Holberton
  'snyder',

  // Frances Spence - one of the original programmers of the ENIAC. https://en.wikipedia.org/wiki/ENIAC - https://en.wikipedia.org/wiki/Frances_Spence
  'spence',

  // Richard Matthew Stallman - the founder of the Free Software movement, the GNU project, the Free Software Foundation, and the League for Programming Freedom. He also invented the concept of copyleft to protect the ideals of this movement, and enshrined this concept in the widely-used GPL (General Public License) for software. https://en.wikiquote.org/wiki/Richard_Stallman
  'stallman',

  // Michael Stonebraker is a database research pioneer and architect of Ingres, Postgres, VoltDB and SciDB. Winner of 2014 ACM Turing Award. https://en.wikipedia.org/wiki/Michael_Stonebraker
  'stonebraker',

  // Janese Swanson (with others) developed the first of the Carmen Sandiego games. She went on to found Girl Tech. https://en.wikipedia.org/wiki/Janese_Swanson
  'swanson',

  // Aaron Swartz was influential in creating RSS, Markdown, Creative Commons, Reddit, and much of the internet as we know it today. He was devoted to freedom of information on the web. https://en.wikiquote.org/wiki/Aaron_Swartz
  'swartz',

  // Bertha Swirles was a theoretical physicist who made a number of contributions to early quantum theory. https://en.wikipedia.org/wiki/Bertha_Swirles
  'swirles',

  // Nikola Tesla invented the AC electric system and every gadget ever used by a James Bond villain. https://en.wikipedia.org/wiki/Nikola_Tesla
  'tesla',

  // Ken Thompson - co-creator of UNIX and the C programming language - https://en.wikipedia.org/wiki/Ken_Thompson
  'thompson',

  // Linus Torvalds invented Linux and Git. https://en.wikipedia.org/wiki/Linus_Torvalds
  'torvalds',

  // Alan Turing was a founding father of computer science. https://en.wikipedia.org/wiki/Alan_Turing.
  'turing',

  // Varahamihira - Ancient Indian mathematician who discovered trigonometric formulae during 505-587 CE - https://en.wikipedia.org/wiki/Var%C4%81hamihira#Contributions
  'varahamihira',

  // Sir Mokshagundam Visvesvaraya - is a notable Indian engineer.  He is a recipient of the Indian Republic's highest honour, the Bharat Ratna, in 1955. On his birthday, 15 September is celebrated as Engineer's Day in India in his memory - https://en.wikipedia.org/wiki/Visvesvaraya
  'visvesvaraya',

  // Christiane Nüsslein-Volhard - German biologist, won Nobel Prize in Physiology or Medicine in 1995 for research on the genetic control of embryonic development. https://en.wikipedia.org/wiki/Christiane_N%C3%BCsslein-Volhard
  'volhard',

  // Marlyn Wescoff - one of the original programmers of the ENIAC. https://en.wikipedia.org/wiki/ENIAC - https://en.wikipedia.org/wiki/Marlyn_Meltzer
  'wescoff',

  // Andrew Wiles - Notable British mathematician who proved the enigmatic Fermat's Last Theorem - https://en.wikipedia.org/wiki/Andrew_Wiles
  'wiles',

  // Roberta Williams, did pioneering work in graphical adventure games for personal computers, particularly the King's Quest series. https://en.wikipedia.org/wiki/Roberta_Williams
  'williams',

  // Sophie Wilson designed the first Acorn Micro-Computer and the instruction set for ARM processors. https://en.wikipedia.org/wiki/Sophie_Wilson
  'wilson',

  // Jeannette Wing - co-developed the Liskov substitution principle. - https://en.wikipedia.org/wiki/Jeannette_Wing
  'wing',

  // Steve Wozniak invented the Apple I and Apple II. https://en.wikipedia.org/wiki/Steve_Wozniak
  'wozniak',

  // The Wright brothers, Orville and Wilbur - credited with inventing and building the world's first successful airplane and making the first controlled, powered and sustained heavier-than-air human flight - https://en.wikipedia.org/wiki/Wright_brothers
  'wright',

  // Rosalyn Sussman Yalow - Rosalyn Sussman Yalow was an American medical physicist, and a co-winner of the 1977 Nobel Prize in Physiology or Medicine for development of the radioimmunoassay technique. https://en.wikipedia.org/wiki/Rosalyn_Sussman_Yalow
  'yalow',

  // Ada Yonath - an Israeli crystallographer, the first woman from the Middle East to win a Nobel prize in the sciences. https://en.wikipedia.org/wiki/Ada_Yonath
  'yonath',
];

export const Adjectives = [
  'admiring',
  'adoring',
  'agitated',
  'amazing',
  'angry',
  'awesome',
  'backstabbing',
  'berserk',
  'big',
  'boring',
  'clever',
  'cocky',
  'compassionate',
  'condescending',
  'cranky',
  'desperate',
  'determined',
  'distracted',
  'dreamy',
  'drunk',
  'ecstatic',
  'elated',
  'elegant',
  'evil',
  'fervent',
  'focused',
  'furious',
  'gigantic',
  'gloomy',
  'goofy',
  'grave',
  'happy',
  'high',
  'hopeful',
  'hungry',
  'infallible',
  'jolly',
  'jovial',
  'kickass',
  'lonely',
  'loving',
  'mad',
  'modest',
  'naughty',
  'nauseous',
  'nostalgic',
  'peaceful',
  'pedantic',
  'pensive',
  'prickly',
  'reverent',
  'romantic',
  'sad',
  'serene',
  'sharp',
  'sick',
  'silly',
  'sleepy',
  'small',
  'stoic',
  'stupefied',
  'suspicious',
  'tender',
  'thirsty',
  'tiny',
  'trusting',
  'zen',
];
